import { useState } from 'react';
import { t } from 'i18next';
import { apiClient } from 'config/api';
import { ProductColors } from '@modules/clients/modules/CompanyDetails/data/hooks/useCustomerLimits';

export interface Account {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  dni: string;
  cuit: string;
  customerId: number;
  products: string;
  categories: string;
  accountId: string;
  balance: string;
  acctNumber: string;
  walletId: string;
  legalName: string;
  status: string;
  productColors: ProductColors;
  areaName: string;
  areaId: string;
}

interface AssignAreaBody {
  areaName: string;
  areaId: string;
  accountIds: Account[];
}
interface setModalParam {
  showModal: boolean;
  title: string;
  description: string;
  variant: string;
}

/** Assign area logic */
const useAssignAreaPartial = (
  setModal: (a: setModalParam) => void,
  closeAssignAreaModal: () => void,
  mutate: () => void
) => {
  const [isError, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);

  /**
   * Assigns an area to an account without assigned area
   * @param body
   * @param body.areaId - The area to assign
   * @param body.accountIds - The ids of the accounts to be assigned
   */
  async function postAssignAreaPartial({ areaName, areaId, accountIds }: AssignAreaBody) {
    try {
      setError(false);
      setLoading(true);
      const ids = accountIds.map((item) => item.accountId);
      await apiClient.patch('/v3/client/assign-area', { areaId, accountIds: ids });
      setModal({
        showModal: true,
        title: 'EMPLOYEES:ASSIGN_AREA_MODAL:SUCCESS_TITLE',
        description: t('EMPLOYEES:ASSIGN_AREA_MODAL:SUCCESS_DESCRIPTION', { areaname: areaName }),
        variant: 'success',
      });
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
      mutate();
      closeAssignAreaModal();
    }
  }

  return { isError, isLoading, postAssignAreaPartial };
};

export default useAssignAreaPartial;
